<template>
  <div class="games-menu" :class="{ 'games-menu--sticky': isSticky }">
    <div
      v-if="menuReady"
      v-dragscroll.x
      class="groups flex row"
      :class="groupsClasses"
      @dragscrollstart="() => changeDraggingStatus(true)"
      @dragscrollend="() => changeDraggingStatus(false)"
    >
      <template v-if="!page">
        <div v-if="showBonusesGroup" class="group-wrap">
          <app-link :to="{ name: 'BonusGames' }" class="swiper-slide group" exact-active-class="group-active">
            <Icon class="group__icon" name="bonuses_games" />
            <span class="group__txt text-center">{{ $t('promoGames') }}</span>
          </app-link>
        </div>
        <!-- TODO: Временный хардкод до реализации 783 задачи-->
        <div v-for="(group, index) in groupsWithWebView" :key="index" class="group-wrap">
          <app-link
            v-if="!group.webView"
            :to="{ name: 'GamesByGroup', params: { group: group.slug } }"
            class="swiper-slide group"
            exact-active-class="group-active"
          >
            <Icon class="group__icon" :name="group.slug" />
            <span class="group__txt text-center">{{ group.label }}</span>
          </app-link>

          <app-link v-else :to="group.to" class="swiper-slide group" exact-active-class="group-active">
            <Icon class="group__icon" :name="group.icon" />
            <span class="group__txt text-center">{{ group.label }}</span>
          </app-link>
        </div>
        <!-- TODO: END Временный хардкод до реализации 783 задачи -->
      </template>

      <template v-else>
        <template v-if="page.key === 'slot'">
          <div class="group-wrap">
            <app-link
              :to="{ name: 'GamesByGroup', params: { group: page.key } }"
              class="swiper-slide group"
              exact-active-class="group-active"
            >
              <Icon class="group__icon" :name="getIconName(page.key)" />
              <span class="group__txt text-center">{{ page.name }}</span>
            </app-link>
          </div>
          <div v-if="showBonusesGroup" class="group-wrap">
            <app-link :to="{ name: 'BonusGames' }" class="swiper-slide group" exact-active-class="group-active">
              <Icon class="group__icon" name="bonuses_games" />
              <span class="group__txt text-center">{{ $t('promoGames') }}</span>
            </app-link>
          </div>
        </template>
        <div v-else class="group-wrap">
          <app-link
            :to="{ name: 'GamesByGroup', params: { group: page.key } }"
            class="swiper-slide group"
            exact-active-class="group-active"
          >
            <Icon class="group__icon" :name="getIconName(page.key)" />
            <span class="group__txt text-center">{{ page.name }}</span>
          </app-link>
        </div>
        <div v-if="showNewGroup" class="group-wrap">
          <app-link
            :to="{ name: 'GamesBySubGroup', params: { group: page.key, subgroup: 'new' } }"
            class="swiper-slide group"
            exact-active-class="group-active"
          >
            <Icon class="group__icon" name="new" />
            <span class="group__txt text-center">{{ $t('new') }}</span>
          </app-link>
        </div>

        <div v-for="group in filteredGroups" :key="group.id" class="group-wrap">
          <app-link
            :to="{ name: 'GamesBySubGroup', params: { group: page.key, subgroup: group.slug } }"
            class="group"
            active-class="group-active"
          >
            <Icon class="group__icon" :name="getIconName(group.slug)" />
            <span class="group__txt text-center">{{ group.name }}</span>
          </app-link>
        </div>
      </template>
    </div>
    <div class="groups flex row full-width --fake">
      <div v-for="i in 8" :key="'fake-' + i" class="group-wrap">
        <div class="group">
          <ol-skeleton class="group__icon" />
          <ol-skeleton class="group__txt" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getGroup from 'src/apollo/queries/getGroup.gql'
import { dragscroll } from 'vue-dragscroll'
import { mapGetters } from 'vuex'
import { OlSkeleton } from '@gamesite/olimp-core'
import { consoleLogAPI } from 'src/common/functions'

export default {
  name: 'GamesMenu',
  directives: {
    dragscroll,
  },
  components: {
    OlSkeleton,
  },
  props: {
    isSticky: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change-scroll'],
  data() {
    return {
      loading: true,
      dragging: false,
      isBeginning: true,
      filteredGroups: [],
    }
  },
  computed: {
    ...mapGetters({ mainGroups: 'getMainGroups' }),
    ...mapGetters(['showBonusesGames', 'activeStepLoaded', 'getAuth', 'isWebView', 'getIsAlt']),
    groupsClasses() {
      return {
        'groups--last': !this.isBeginning,
        'groups--dragging': this.dragging,
      }
    },
    groupSlug() {
      return this.$route.params.group
    },
    showBonusesGroup() {
      if (!this.page || this.page.key === 'slot') {
        return this.showBonusesGames
      }
      return false
    },
    menuReady() {
      if (this.getAuth) {
        if (!this.page || this.page.key === 'slot') {
          return !this.loading && this.activeStepLoaded
        }
        return !this.loading
      }
      return !this.loading
    },
    page() {
      if (this.groupSlug === 'slot') {
        return {
          key: 'slot',
          name: this.$t('slots'),
        }
      }

      switch (this.groupSlug) {
        case 'online': {
          return {
            key: 'online',
            name: this.$t('live_casino'),
          }
        }
        case 'fast': {
          return {
            key: 'fast',
            name: this.$t('instant'),
          }
        }
        case 'vsport': {
          return {
            key: 'vsport',
            name: this.$t('virtuals'),
          }
        }
        case 'table': {
          return {
            key: 'table',
            name: this.$t('table'),
          }
        }
        case 'lottery': {
          return {
            key: 'lottery',
            name: this.$t('lottery'),
          }
        }
        case 'worldcup': {
          return {
            key: 'worldcup',
            name: this.$t('WorldCup'),
          }
        }
        default: {
          return null
        }
      }
    },
    showNewGroup() {
      return this.groupSlug !== 'worldcup'
    },
    groupsWithWebView() {
      // в вебвью версии нужен именно такой порядок: gamesite-763
      if (this.isWebView && this.getIsAlt) {
        const position = [
          'slot',
          'online',
          'fast',
          'aviator',
          'betgames',
          'jetx',
          'aviatrix',
          'lottery',
          'table',
          'vsport',
          'other',
        ]

        const webViewUniqueGroups = [
          {
            webView: true,
            to: { name: 'GamePageNew', params: { game: 'spribe-aviator', manufacturer: 'spribe' } },
            icon: 'corncob_plane',
            label: this.$t('navGamesCat.aviator'),
            slug: 'aviator',
          },
          {
            webView: true,
            to: { name: 'GamePageNew', params: { game: 'wheeloffortunebg', manufacturer: 'bg' } },
            icon: 'betgame',
            label: this.$t('navGamesCat.betGames'),
            slug: 'betgames',
          },
          {
            webView: true,
            to: { name: 'GamePageNew', params: { game: 'aviatrix-nft-aviatrix', manufacturer: 'avx' } },
            icon: 'air_screw',
            label: this.$t('navGamesCat.aviatrix'),
            slug: 'aviatrix',
          },
          {
            webView: true,
            to: {
              name: 'GamePageNew',
              params: { game: 'aviatrix-lobby', manufacturer: 'sgtv' },
            },
            icon: 'speed_s',
            label: this.$t('navGamesCat.sportGames'),
            slug: 'sgtv',
          },
          {
            webView: true,
            to: {
              name: 'GamePageNew',
              params: { game: 'smartsoft-jetx', manufacturer: 'smartsoft' },
            },
            icon: 'jetx',
            label: this.$t('navGamesCat.jetx'),
            slug: 'jetx',
          },
        ]

        const groupsToRemove = ['new']

        const sortedGroup = []
        const undefinedGroup = []

        this.mainGroups.forEach((group) => {
          const index = position.findIndex((el) => el === group.slug)

          if (index >= 0) {
            sortedGroup[index] = group
          } else {
            undefinedGroup.push(group)
          }
        })

        webViewUniqueGroups.forEach((group) => {
          const index = position.findIndex((el) => el === group.slug)

          if (index >= 0) {
            sortedGroup[index] = group
          }
        })

        return [...sortedGroup, ...undefinedGroup]?.filter((i) => {
          return i !== undefined && !groupsToRemove.includes(i.slug)
        })
      }

      return this.mainGroups
    },
  },

  watch: {
    groupSlug: {
      handler(value) {
        this.getGroups()
        // if the immediate watch flag is true, it is triggered before the component is mounted
        if (this.$el && value) {
          this.$el.removeEventListener('scroll', this.onScroll)
          this.$el.addEventListener('scroll', this.onScroll)
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.$el.addEventListener('scroll', this.onScroll)
  },
  beforeUnmount() {
    this.$el.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    getIconName(icon) {
      return icon.includes('_live') ? icon.replace('_live', '') : icon
    },
    filterGroups(groups) {
      const exceptedGroups = ['new']

      if (this.page?.key === 'slot') {
        return groups?.filter((g) => {
          if (g.code === 'tournament' || g.games.totalCount) {
            return g.code !== 'slot' && !exceptedGroups.includes(g.code) && g.showInMenu
          }
          return false
        })
      }

      return groups?.filter((g) => {
        if (g.code === 'tournament' || g.games.totalCount) {
          return !exceptedGroups.includes(g.code) && g.showInMenu
        }
        return false
      })
    },

    onScroll() {
      const scrollLeft = this.$el.scrollLeft
      let scrollActive = 'start'

      if (this.$el.scrollWidth - scrollLeft === this.$el.offsetWidth) {
        scrollActive = 'end'
      } else if (scrollLeft === 0) {
        scrollActive = 'start'
      } else {
        scrollActive = 'in-range'
      }

      this.$emit('change-scroll', scrollActive)
    },

    getGroups() {
      const exceptedGroups = ['slot', 'online', 'fast', 'vsport', 'lottery', 'table', 'worldcup']
      const slug = this.groupSlug || 'slot'

      const variables = {
        slug: exceptedGroups.includes(slug) ? slug : 'slot',
      }

      this.loading = true
      this.$apollo
        .query({
          query: getGroup,
          variables,
        })
        .then(({ data }) => {
          this.filteredGroups = this.filterGroups(data.gameGroup?.subgroups)
        })
        .catch(consoleLogAPI)
        .finally(() => {
          this.loading = false
        })
    },
    changeDraggingStatus(status) {
      this.dragging = status
    },
  },
}
</script>

<style scoped lang="scss">
.games-menu {
  height: 80px;

  &--sticky {
    height: 56px;

    .groups .group-wrap {
      height: 40px;
    }

    .groups .group__txt {
      line-height: 0;
      font-size: 0;
    }
  }
}

.group-wrap {
  width: 100%;
  min-width: 172px;

  @media (max-width: 575px) {
    flex-basis: auto;
  }
}

.groups {
  margin: 0;
  position: relative;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  padding-bottom: 20px;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
  transition: 0.1s;

  &__nav {
    font-size: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    z-index: 1;
    opacity: 1;
    visibility: visible;
    transition: 0.3s;

    &.swiper-button-disabled {
      opacity: 0;
      visibility: hidden;
    }

    &-left {
      left: 0;
    }

    &-right {
      right: 0;
    }
  }

  &--last {
    &:after {
      opacity: 0;
      visibility: hidden;
    }
  }

  &--dragging {
    pointer-events: none;
  }

  .group {
    width: 100%;
    height: 100%;
    color: white;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-radius: var(--radius-radius-card, 4px);
    background: var(--cas-main-deep-2);
    row-gap: 8px;

    &__icon {
      width: 32px;
      height: 32px;
      flex-shrink: 0;
      opacity: 0.7;
    }

    &__txt {
      position: relative;
      display: block;
      margin: 0;
      font-size: 14px;
      white-space: nowrap;
      transition: 0.3s;
      opacity: 0.7;
    }

    &-wrap {
      height: 80px;

      &-image {
        position: relative;
        height: 30px;

        img {
          height: 100%;
          opacity: 1;

          &.active {
            opacity: 0;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }

    &-active {
      color: var(--cas-secondary);
      border: 1px solid #f6a913;

      .group__icon {
        opacity: 1;
      }

      .group__txt {
        opacity: 1;
      }

      &:hover {
        cursor: default;
      }
    }
  }

  &.--fake {
    .group {
      padding: 8px;
    }
    .group__txt {
      width: 45%;
      height: 10px;

      @media screen and (max-width: 767px) {
        height: 7.5px;
      }
    }
  }
}

.button-nav {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  transition: 0.3s;

  //&::v-deep {
  //  svg {
  //    height: 20px;
  //    width: auto;
  //
  //    g,
  //    path {
  //      stroke: white;
  //    }
  //  }
  //}

  &.swiper-button-disabled {
    display: none;
  }

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}

@media screen and (max-width: 1503px) {
  .proup-wrap {
    min-width: 100px;
  }
}

@media screen and (min-width: 1460px) {
  .groups__nav-right {
    display: none;
  }
}

@media screen and (max-width: 1400px) {
  .groups .group {
    padding: 12px;
  }
}

@media screen and (max-width: 1023px) {
  .group-wrap {
    min-width: 116px;
  }
  .groups .group {
    padding: 15px 5px;
  }
}

@media screen and (max-width: 767px) {
  .games-menu {
    height: 60px;
  }

  .groups {
    gap: 6px;
    overflow-y: hidden;

    .group {
      row-gap: 0;

      &__icon {
        width: 24px;
        height: 24px;
      }

      &__txt {
        font-size: 10px;
      }

      &-wrap {
        height: 60px;
      }
    }
  }

  .group-wrap {
    min-width: 70px;
    height: 60px;
    transition: 0.1s ease-in-out;
  }
}

@media screen and (max-width: 575px) {
  .groups {
    &__nav {
      background-color: var(--cas-grey-5);
      width: 32px;
      height: 32px;
      opacity: 0.8;
      font-size: 26px;
      display: none;

      &-left {
        border-top-right-radius: var(--radius-1);
        border-bottom-right-radius: var(--radius-1);
      }

      &-right {
        border-top-left-radius: var(--radius-1);
        border-bottom-left-radius: var(--radius-1);
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .groups {
    &__nav {
      font-size: 22px;
      width: 30px;
      height: 30px;
    }
  }
}
</style>
